import {
  FaPhoneAlt, // Ikon untuk Nomor Telepon
  FaCalendarAlt, // Ikon untuk Tanggal Transaksi
  FaCreditCard, // Ikon untuk Kode Pembayaran
  FaCheckCircle, // Ikon untuk Status Sukses
  FaExclamationCircle,
  FaStore,
  FaDollarSign,
  FaClipboard,
  FaSpinner,
  FaCalendarCheck,
  FaTag,
  FaMoneyBillWave,
  FaMobileAlt,
  FaCopy,
  FaNotesMedical,
  FaFileInvoice,
  FaRegCreditCard,
  FaCertificate, // Ikon untuk Status Gagal
} from "react-icons/fa";
import { motion } from "framer-motion"; // Untuk animasi ringan
import { useNavigate, useParams } from "react-router-dom";
import {
  useCancelTransaction,
  useGetTransactionById,
  useRetryTransaction,
} from "../../../features/transaction";
import NumberFormat from "../../../utils/NumberFormat";
import { toast } from "react-toastify";
import { safeDateFormat } from "../../../utils/saveDateFormat";
import ModalConfirmationDelete from "../../../components/ModalConfirmationDelete";
import { useState } from "react";
import { FiChevronLeft } from "react-icons/fi";

const TransactionDetailPage = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenRetry, setIsModalOpenRetry] = useState(false);
  const { transaction: transactionId } = useGetTransactionById(id);
  const { cancelTransaction } = useCancelTransaction();
  const { retryTransaction } = useRetryTransaction();

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpenRetry(false);
    setIsModalOpen(false);
  };

  const handleConfirmDelete = () => {
    // Logika untuk membatalkan transaksi atau tindakan lainnya
    console.log("Transaksi dibatalkan!");
    cancelTransaction(transactionId?.transaction?.id, {
      onSuccess: () => {
        setIsModalOpen(false);
      },
    });
  };
  const router = useNavigate();

  const copyToClipboard = () => {
    const invoiceUrl = transactionId?.details?.invoiceUrl;
    if (invoiceUrl) {
      navigator.clipboard.writeText(invoiceUrl);
      toast.success("URL berhasil disalin!");
    }
  };

  const handleConfirmRetry = () => {
    retryTransaction(transactionId?.transaction?.id, {
      onSuccess: () => {
        setIsModalOpenRetry(false);
      },
    });
  };

  return (
    <>
      <div className="p-6 max-w-4xl mx-auto bg-white border-t-4">
        <div className="relative flex items-center justify-center mb-6">
          <button className="absolute left-0">
            <FiChevronLeft
              className="w-5 h-5 text-gray-500"
              onClick={() => router(-1)}
            />
          </button>
          <h2 className="text-base font-semibold text-gray-800">Detail</h2>
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
          className="space-y-6"
        >
          <div className="text-xs text-gray-400">Transaction</div>
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <FaCalendarCheck className="text-blue-500 mr-2" size={20} />
              <p className="text-xs font-medium text-gray-700">
                Transaction Date:
              </p>
            </div>
            <p className="text-xs text-gray-600">
              {safeDateFormat(transactionId?.transaction?.createdAt, true)}
            </p>
          </div>

          {/* Payment Info */}
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <FaRegCreditCard className="text-blue-500 mr-2" size={20} />
              <p className="text-xs font-medium text-gray-700">
                Jenis Pembayaran:
              </p>
            </div>
            <p className="text-xs text-gray-600">
              {transactionId?.transaction?.paymentType}
            </p>
          </div>
          {transactionId?.transaction?.paymentType === "DIRECT" &&
            transactionId?.transaction?.invoiceId !== "invoiceId" && (
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <FaCertificate className="text-blue-500 mr-2" size={20} />
                  <p className="text-xs font-medium text-gray-700">
                    Verify OTP:
                  </p>
                </div>
                <p
                  className="text-xs text-blue-600 cursor-pointer"
                  onClick={() =>
                    navigate(
                      `/add-order/verify-otp/${transactionId?.transaction?.idtrx}`
                    )
                  }
                >
                  OTP
                </p>
              </div>
            )}

          {/* Status */}
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              {transactionId?.transaction?.status === "PAID" ? (
                <FaCheckCircle className="text-green-500 mr-2" size={20} />
              ) : (
                <FaExclamationCircle className="text-blue-500 mr-2" size={20} />
              )}
              <p className="text-xs font-normal text-gray-700">Status:</p>
            </div>
            <span
              className={`text-xs ${
                transactionId?.transaction?.status === "PAID"
                  ? "text-green-600"
                  : "text-primary-600"
              }`}
            >
              {transactionId?.transaction?.status}
            </span>
          </div>
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <FaPhoneAlt className="text-blue-500 mr-2" size={20} />
              <p className="text-xs font-medium text-gray-700">Customer:</p>
            </div>
            <p className="text-xs text-gray-600 w-52 text-right">
              {transactionId?.transaction?.customerName} - (
              {transactionId?.transaction?.customerPhone})
              <div>{transactionId?.transaction?.customerEmail}</div>
            </p>
          </div>

          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <FaMobileAlt className="text-blue-500 mr-2" size={20} />
              <p className="text-xs font-medium text-gray-700">Phone:</p>
            </div>
            <p className="text-xs text-gray-600  w-52 text-right">
              {transactionId?.transaction?.phone}
            </p>
          </div>
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <FaNotesMedical className="text-blue-500 mr-2" size={20} />
              <p className="text-xs font-medium text-gray-700">Note:</p>
            </div>
            <p className="text-xs text-gray-600 w-52 text-right">
              {transactionId?.transaction?.note ?? "-"}
            </p>
          </div>
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <FaMoneyBillWave className="text-blue-500 mr-2" size={20} />
              <p className="text-xs font-medium text-gray-700">Price:</p>
            </div>
            <p className="text-xs text-gray-600  w-52 text-right">
              <NumberFormat
                value={transactionId?.transaction?.price}
                prefix="Rp. "
              />
            </p>
          </div>
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <FaDollarSign className="text-blue-500 mr-2" size={20} />
              <p className="text-xs font-medium text-gray-700">Admin Fee:</p>
            </div>
            <p className="text-xs text-gray-600  w-52 text-right">
              <NumberFormat
                value={
                  transactionId?.transaction?.totalPrice -
                  transactionId?.transaction?.price
                }
                prefix="Rp. "
              />
            </p>
          </div>
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <FaTag className="text-blue-500 mr-2" size={20} />
              <p className="text-xs font-medium text-gray-700">Discount:</p>
            </div>
            <p className="text-xs text-gray-600  w-52 text-right">
              <NumberFormat
                value={transactionId?.transaction?.discount}
                prefix="Rp. "
              />
            </p>
          </div>
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <FaCreditCard className="text-blue-500 mr-2" size={20} />
              <p className="text-xs font-medium text-gray-700">Total Price:</p>
            </div>
            <p className="text-xs text-gray-600  w-52 text-right">
              <NumberFormat
                value={transactionId?.transaction?.totalPrice}
                prefix="Rp. "
              />
            </p>
          </div>

          <div className="text-xs text-gray-400">Xendit</div>
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <FaStore className="text-blue-500 mr-2" size={20} />
              <p className="text-xs font-medium text-gray-700">
                Nama Merchane:
              </p>
            </div>
            <p className="text-xs text-gray-600 text-right">
              {transactionId?.details?.merchantName ?? "-"}
            </p>
          </div>

          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <FaCalendarAlt className="text-blue-500 mr-2" size={20} />
              <p className="text-xs font-medium text-gray-700">Expire Date:</p>
            </div>
            <p className="text-xs text-gray-600">
              {safeDateFormat(transactionId?.details?.expiryDate, true)}
            </p>
          </div>

          {/* Transaction Info */}
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <FaDollarSign className="text-blue-500 mr-2" size={20} />
              <p className="text-xs font-medium text-gray-700">Amount:</p>
            </div>
            <p className="text-xs text-gray-600">
              <NumberFormat
                value={transactionId?.details?.amount}
                prefix="Rp. "
              />
            </p>
          </div>

          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <FaClipboard className="text-blue-500 mr-2" size={20} />
              <p className="text-xs font-medium text-gray-700">Description:</p>
            </div>
            <p className="text-xs text-gray-600  w-52 text-right">
              {transactionId?.details?.description ?? "-"}
            </p>
          </div>
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <FaSpinner className="text-blue-500 mr-2" size={20} />
              <p className="text-xs font-medium text-gray-700">Status:</p>
            </div>
            <p className="text-xs text-gray-600  w-52 text-right">
              {transactionId?.details?.status ?? "-"}
            </p>
          </div>
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <FaFileInvoice className="text-blue-500 mr-2" size={20} />
              <p className="text-xs font-medium text-gray-700">Invoice URL:</p>
            </div>
            <div className="flex items-center">
              <button
                onClick={copyToClipboard}
                className="text-xs text-blue-500 hover:text-blue-700 focus:outline-none"
                aria-label="Copy URL"
              >
                <FaCopy size={16} />
              </button>
            </div>
          </div>
        </motion.div>

        <div className="flex items-center text-center justify-center gap-5">
          {/* Button */}
          {transactionId?.transaction?.status !== "SUCCESS" &&
            transactionId?.transaction?.status !== "FAILED" &&
            transactionId?.transaction?.status !== "CANCELED" && (
              <>
                <motion.div
                  className="mt-8 text-center"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 1, duration: 0.5 }}
                >
                  <button
                    className="px-6 py-2 border border-red-500  text-red-500 text-xs rounded-md hover:bg-red-700 hover:text-white transition duration-300 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50"
                    onClick={handleOpenModal}
                  >
                    Batalkan Transaction
                  </button>
                </motion.div>
              </>
            )}
          {transactionId?.transaction?.status === "FAILED" && (
            <motion.div
              className="mt-8 text-center"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 1, duration: 0.5 }}
            >
              <button
                className="px-6 py-2 border border-red-500  text-red-500 text-xs rounded-md hover:bg-red-700 hover:text-white transition duration-300 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50"
                onClick={() => setIsModalOpenRetry(true)}
              >
                Retry Transaction
              </button>
            </motion.div>
          )}
          {transactionId?.transactionLogs?.length > 0 && (
            <motion.div
              className="mt-8 text-center"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 1, duration: 0.5 }}
            >
              <button
                className="px-6 py-2 border border-orange-500  text-orange-500 text-xs rounded-md hover:bg-orange-700 hover:text-white transition duration-300 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-opacity-50"
                onClick={() => router(`/order-list/logs/${id}`)}
              >
                Transaction Log
              </button>
            </motion.div>
          )}
        </div>
      </div>
      <ModalConfirmationDelete
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onConfirm={handleConfirmDelete}
      />
      <ModalConfirmationDelete
        isOpen={isModalOpenRetry}
        onClose={handleCloseModal}
        onConfirm={handleConfirmRetry}
      />
    </>
  );
};

export default TransactionDetailPage;
